export const Theme = {
  PrimaryGrey: "#62707B",
  PrimaryDark: "#2F2A3A",

  PrimaryBackground: "#F7F5FB",
  PrimaryGreen: "#59d973",
  PrimaryMint: "#95fd35",
  PrimaryRed: "#d9486f",
  PrimaryYellow: "#F2C02E",
  PrimaryOrange: "#EF7E23",
  PrimaryBlue: "#825efb",
  SecondaryColor: "#be7efc",
  TertiaryColor: "#ecdbfe",

  PrimaryFont: "Inter",

  PrimaryBorderColor: "#EBE7F3",
  PrimaryFade: "#FAF9FC",
  PrimaryInputOutline: "#E6E2EF",
  PrimaryCellPad: "15px",

  PrimaryBorderRadius: "8px",
  PrimaryFontSize: "12px",
};